
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface CustomInstructionsInputProps {
  customInstructions: string;
  onCustomInstructionsChange: (value: string) => void;
  maxChars: number;
}

const CustomInstructionsInput = ({ 
  customInstructions, 
  onCustomInstructionsChange, 
  maxChars 
}: CustomInstructionsInputProps) => {
  const charCount = customInstructions.length;
  const isOverLimit = charCount > maxChars;

  return (
    <div className="space-y-2 pt-2">
      <Label>Custom Instructions</Label>
      <Textarea
        value={customInstructions}
        onChange={(e) => onCustomInstructionsChange(e.target.value)}
        placeholder="Example: Demand full refund or we'll hire a lawyer. Use stronger language about consumer rights."
        className={`min-h-[150px] ${isOverLimit ? 'border-red-500' : ''}`}
      />
      
      <div className="flex justify-end">
        <p className={`text-xs ${isOverLimit ? 'text-red-500' : 'text-muted-foreground'}`}>
          {charCount}/{maxChars} characters
        </p>
      </div>
    </div>
  );
};

export default CustomInstructionsInput;
